import { render, staticRenderFns } from "./InvestorDetail.vue?vue&type=template&id=d5a1699e&"
import script from "./InvestorDetail.vue?vue&type=script&lang=js&"
export * from "./InvestorDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports